import Navigation from "../../../../components/header";
import { Container } from "@mui/material";

const MonthlySummaryByMaterialCostCreditReport = () => {
	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
			<h1 className="report-header">Monthly Summary By Material Report (Cost/Credit)</h1>
				{/* <iframe title="HWIOnline_MonthlySummaryByMaterialCostCredit_DEV" width="1140" height="541.25" src="https://app.powerbi.com/reportEmbed?reportId=9d50f57d-c734-412c-b8b6-128d0db9bc3a&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe> */}
				<iframe title="HWIOnline_MonthlySummaryByCostCredit" width="1140" height="700" src="https://app.powerbi.com/reportEmbed?reportId=e6a93629-bc93-43d2-bdce-95dcc42f4126&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2" frameBorder="1"></iframe>
			</Container>
		</>
	);
};

export default MonthlySummaryByMaterialCostCreditReport;